export default __webpack_public_path__ + "static/media/icon_failed.8a1e6fab.svg";